import React, { useState } from 'react'

import classNames from 'classnames'

import NFIcon from '@components/shared/NFIcon'
import { getScoreIcon } from '@models/util/score.util'
import { useSelection } from '@providers/SelectionProvider'

import type Product from '@models/Product'
import type Score from '@models/Score'

interface Props {
  score: Score | Product
}

const IconHandle: React.FC<Props> = ({ score }: Props) => {
  const { isSelected, events, isEditing } = useSelection<Score | Product>()
  const [hover, setHover] = useState(false)

  const selected = isSelected(score)
  return (
    <NFIcon
      icon={getScoreIcon(score, hover || isEditing, selected)}
      className={classNames(
        'w-[25px] text-center mr-3.5',
        hover || selected || isEditing ? 'text-xl' : 'text-h3',
        selected ? 'text-blue' : 'text-gray-icons dark:text-gray-icons-dm'
      )}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onMouseDown={(e) => events.onMouseDown(score, e)}
      onMouseUp={(e) => events.onMouseUp(score, e)}
      onTouchStart={(e) => events.onTouchStart(score, e)}
      onTouchEnd={(e) => events.onTouchEnd(score, e)}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    />
  )
}

export default IconHandle
